import { queryUrlValue } from "./index";

setTimeout ( function () {
  try {
    const url = decodeURIComponent(window.location.href);
    const navIdx = queryUrlValue("idx");
    const navDom = document.querySelector("#nav");
    const navLine = navDom.querySelector("#navLine");
    const navItems = navDom.querySelectorAll(".nav-item");
    const nowItem = navItems[Number(navIdx)];
    nowItem.className += " nav-item__active";
    const firstNavItem = navIdx
      ? nowItem
      : navDom.querySelector(".nav-item__active");
  
    function computeLeft(item, line) {
      let l = item.offsetLeft;
      let w = item.clientWidth;
      let lineW = line.clientWidth;
      return l + w / 2 - lineW / 2 + "px";
    }
  
    const initLeft = computeLeft(firstNavItem, navLine);
    navLine.style.left = initLeft;
    setTimeout(() => (navLine.style.opacity = 1), 300);
  
    navItems.forEach((item) => {
      item.onmouseover = function (e) {
        this.childNodes[0].style.color = "#EF823A";
        navLine.style.left = computeLeft(this, navLine);
      };
  
      item.onmouseout = function () {
        this.childNodes[0].style.color = "#808080";
        navLine.style.left = initLeft;
      };
    });
  
    /** 搜索相关逻辑 */
    const searchDom = document.querySelector("#search");
    if (url.includes("newsSearch")) {
      searchDom.focus()
    } else {
      searchDom.addEventListener("click", function (e) {
        window.location.href = "newsSearch.html";
        searchDom.removeEventListener("click");
      });
    }
  } catch (error) {
    console.log(error);
  }
  
}, 200)
